import './App.css';
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import { useEffect } from 'react';
import ChatPage from './pages/chatPage';
import DatabaseConfigPage from './pages/DatabaseConfig';
import LLMInstructions from './pages/LLMInstructions';
import TableColumnConfig from './pages/TableColumnConfig';
import OnboardingGuard from './components/OnboardingGuard';
import EmbedLogin from './pages/EmbedLogin';
import EmbedDashboard from './pages/EmbedDashboard';
import CreateCollection from './pages/CreateCollection';
import LiveLoginPage from './pages/LiveLoginPage';
import { ThemeProvider } from './contexts/ThemeContext';

// A bare <Navigate to="/live-login" /> drops the current URL's hash/query on
// the way there. If a Rage token handoff ever arrives at "/", "/login", or
// "/signup" instead of directly at "/live-login", that would silently lose
// the token. This preserves whatever hash/query the browser actually has.
const RedirectPreservingTokenHandoff = () => {
  useEffect(() => {
    window.location.replace(`/live-login${window.location.search}${window.location.hash}`);
  }, []);
  return null;
};

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RedirectPreservingTokenHandoff />} />
            <Route path="/login" element={<RedirectPreservingTokenHandoff />} />
            <Route path="/signup" element={<RedirectPreservingTokenHandoff />} />
            <Route path="/live-login" element={<LiveLoginPage />} />
            <Route path="/embed" element={<EmbedLogin />} />
            <Route path="/embed/dashboard" element={<EmbedDashboard />} />
            <Route path="/home" element={<OnboardingGuard><ChatPage /></OnboardingGuard>} />
            <Route path="/database-config" element={<OnboardingGuard><DatabaseConfigPage /></OnboardingGuard>} />
            <Route path="/llm-instructions" element={<OnboardingGuard><LLMInstructions /></OnboardingGuard>} />
            <Route path="/table-column-config" element={<OnboardingGuard><TableColumnConfig /></OnboardingGuard>} />
            <Route path="/create-collection" element={<OnboardingGuard><CreateCollection /></OnboardingGuard>} />
            <Route path="/store-performance" element={<Navigate to="/home" replace />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
